export default __webpack_public_path__ + "static/media/logo_inferior.7e6fa30b.svg";